import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { HostFamilyOlComment } from '../../../lib/types/models/host-family-ol-comment/host-family-ol-comment'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getHostFamilyOlComments(input: PaginationRequest & { hostFamilyId: number }) {
  const { hostFamilyId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.hostFamilies.getHostFamilyOlComments.url, { hostFamilyId }),
        rest
      )
    )
    .get<PaginationResponse<HostFamilyOlComment>>()
}
